module.exports = require("@adc/fetch");